import Studio1 from "./1.png";
import Studio2 from "./2.png";
import Studio3 from "./3.png";
import Studio4 from "./4.png";

const studioimages = [Studio1, Studio2, Studio3, Studio4];

export default studioimages;
